import axios from "axios";
import { getTokenForStorage } from "../store/storage";

export const updatePics = ({ config, url }: any): Promise<any> => {
        
    const jwtToken: string | null = getTokenForStorage()

    return axios.request({
        ...config, 
        url: `${url}`,
        headers: {
            Authorization: `Bearer ${jwtToken}`
        }
    }).then(response => response.data)
}